export class ChannelFilter {
  names?: string[];
}
